import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

import {ReactComponent as SvgDecoratorBlob1} from "images/svg-decorator-blob-1.svg";
import JeffGIF from "images/new-ui-imgs/Section 1 BG.png/";
import LiveTopMobImg from "images/new-ui-imgs/live-top-mob-img.png";
import {PrimaryButton as PrimaryButtonBase} from "../misc/Buttons";
import logo from "../../images/mai-logo.png";
import {LogoLink} from "../headers/light";

const TwoColumn = tw.div`flex flex-col lg:flex-row lg:items-center max-w-screen-xl mx-auto sm:pt-0 md:pt-20 md:pb-20`;
const LeftColumn = tw.div`relative lg:w-1/2 max-w-lg lg:max-w-none lg:text-left p-8`;

const Button = styled(PrimaryButtonBase)`
    ${tw`rounded-full uppercase tracking-wider py-4 text-sm hover:shadow-xl transform hocus:translate-x-px hocus:-translate-y-px focus:shadow-outline`}
`;
const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl leading-tight`;
export const Subheading = tw.h3`font-bold text-xl text-secondary-500 mt-10 mb-2`

const Container = styled.div`${tw`relative`}
.bg-img {
    ${tw`absolute w-full left-0 top-0 md:h-full`}
}  
    .desktop-img {
       ${tw`hidden md:block`}
   }

    .mob-img {
        ${tw`block md:hidden h-full`}
    }
    
`;

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
    ${tw`pointer-events-none opacity-5 absolute left-0 bottom-0 h-64 w-64 transform -translate-x-2/3 -z-10`}
`;

const HighlightedText = tw.span`text-primary-500`;

export default ({roundedHeaderButton, onClick}) => {
    return (
        <>
            <Container>
                <img className="bg-img desktop-img" src={JeffGIF} alt="JEF Illustration" style={{objectFit: "cover"}}/>
                {/*<img className="bg-img mob-img" src={LiveTopMobImg} alt="JEF Illustration" style={{objectFit: "cover", opacity: 0.3}}/>*/}
                <TwoColumn>
                    <LeftColumn>
                        <LogoLink href="/">
                            <img src={logo} alt="logo"/>
                            MAI Motion
                        </LogoLink>

                        <Subheading>Tired of Nagging Pain?</Subheading>
                        <Heading>
                            <HighlightedText>
                                Get Your Free AI Body
                                <br/> Scan Today.
                            </HighlightedText>
                        </Heading>
                        <Subheading>A smarter way to fix pain, posture, and performance — no physio needed.</Subheading>


                        <Button style={{ marginTop: 40 }} onClick={onClick ? onClick : () => window.open("https://app.maimotion.com")}>
                            START FREE SCAN
                        </Button>
                        {/*  <CustomersLogoStrip>
                            <p>Supported By</p>
                            <div className="images">
                                <img src={Innovate} alt="Innovate UK"/>
                                <img src={UniversityOfLincoln} alt="University of Lincoln"/>
                                <img src={MskDoctors} alt="MSK Doctors"/>
                                <img src={RegenMan} alt="Regeneration Man"/>
                            </div>
                        </CustomersLogoStrip>*/}
                    </LeftColumn>
                </TwoColumn>
                <DecoratorBlob1/>
            </Container>
        </>
    );
};
